import { useQuery } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../lib/query/listQuery';
import { getOfferingCategories } from '../api/offeringCategories';
import type { GetOfferingCategoriesParams } from '../types';

export function useOfferingCategories(params: GetOfferingCategoriesParams = {}) {
  return useQuery({
    queryKey: ['offering-categories', params],
    queryFn: () => getOfferingCategories(params),
    ...listQueryDefaults,
  });
}
